import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Field } from 'formik';
import React from 'react';

export const ShareData = () => (
  <>
    <h5 className="border-bottom pb-2 mb-3">
      <FontAwesomeIcon icon="share" className="mx-1" /> Comparte Honorarios
    </h5>

    <div
      role="group"
      className="contenedorBtn"
      aria-labelledby="my-radio-group"
    >
      <label className="border px-3 py-2 bg-soft-success me-3">
        <Field type="radio" name="share" value="50" className="me-2" />
        Comparte al 50%
      </label>

      <label className="border px-3 py-2 bg-soft-info me-3">
        <Field type="radio" name="share" value="30" className="me-2" />
        Comparte al 30%
      </label>

      <label className="border px-3 py-2 bg-light">
        <Field type="radio" name="share" value="" className="me-2" />
        No Comparte
      </label>
    </div>
  </>
);
